export const exploreLinks = [
  { label: 'Home', url: '' },
  { label: 'The Scan', url: 'the-scan' },
  { label: 'For Patients', url: 'for-patients' },
  { label: 'For Providers', url: 'for-providers' },
  { label: 'For Employers', url: 'for-employers' },
  { label: 'Research', url: 'research' },
  { label: 'Stories', url: 'stories' },
];
export const resourcesLinks = [
  { label: 'Pricing', url: 'pricing' },
  { label: 'Locations', url: 'locations' },
  { label: 'FAQ', url: 'faq' },
  { label: 'Blog', url: 'blog' },
];
export const aboutPrenuvoLinks = [
  { label: 'About us', url: 'about' },
  { label: 'Careers', url: 'careers-at-prenuvo' },
  { label: 'Newsroom', url: 'newsroom' },
  { label: 'Contact', url: 'contact' },
];
